export enum ChemicalExposurePlacement {
  Inside = 1,
  Outside = 2,
}
